import { HtmlEntities } from '@wf-sl/common-utilities'

import { toDate } from '../converter/to-date'

/**
 * Generic wrapper for intl.formatDate, adding a Date conversion to format string ISO 8601 representations,
 * accepts a format (see intl date formats), so accepts
 * - ISO 8601 dates
 * - Numeric timestamps
 * - Pure Date objects
 * as rest resources use to work with the two first types and Date is the one created by developers
 * @param {Intl} intl - Global modux intl helper.
 * @param {string|number|Date} date - value to format
 * @param {string} format - intl formats
 * @param {string} noDateValue - presentational representation when date is undefined or non valid
 * @returns {string}
 */
export function applyDateFormat(intl, date, format = 'defaultDate', noDateValue = HtmlEntities.MDASH) {
    // convert to date to allow ISO 8601 string dates be accepted by intl.formatDate
    const toValidDateObject = toDate(date)
    return toValidDateObject instanceof Date ? intl.formatDate(toValidDateObject, format) : noDateValue
}
